<!--
 * A Vue component to load an image.
 *
 *
 * Properties
 * ==========
 * - name -
 * (Optional) The text that is used as id and name for all elements.
 *
 * - maxFileSize -
 * (Optional) A file size to validate against.
 *   If the image to load is bigger than provide maxFileSize, an error is shown.
 *
 * - value -
 * (Optional) To set the initial value of the input element.
 *
 *
 * Events
 * ==========
 * - input -
 * This event is sent when user changes the input value.
 * The object to sent along with this event is a base64 image file.
 *
 * Usage
 * ==========
 * -It is not mandatory to listen to the emitted input event from this component.
 * Jus use the v-model in your parent component to pass the intial value to this component
 * and receive the new loaded image from this component automatically.
 *
 *-You can put the standard html input attributes, sucht as required,
 * autofocus, etc. directly from the parent component without explicit binding.
-->
<template>
    <div id="feedback-imageviewer-container">
        <b-form-group id="fieldset-1"
                      :description="description"
                      :label="text"
                      :label-for="name"
                      :label-class="labelClass"
                      :label-size="labelSize">
            <div :id="`input_${name}`" class="photo-group">
                <img
                    ref="imageViewer"
                    :id="`image-viewer-${name}`"
                    :name="name"
                    class="feedback-photo-image"
                    :src="imageData"
                    alt=""
                    :data-fieldname="name"
					 v-on:click="$_clickImage($event)">
                <div v-if="enableRemove" class="photo-control" v-on:click="$_removeImage">
                    <em class="fas fa-trash-alt fa-sm photo-icon" style="color:#007AC9; margin-left:10px;" aria-hidden="true"></em>
                    <span class="photo-title">Foto verwijderen</span>
                </div>
            </div>
        </b-form-group>
    </div>
</template>

<script>
    export default {
        inheritAttrs: false,
        name: 'FeedbackImageViewer',
        props: {
            description: { type: String, required: false },
            name: { type: String, required: false, default: 'feedbackImageViewer-input' },
            text: { type: String, required: false, default: '' },
            labelSize: { type: String, required: false, default: '' },
            value: { type: String, required: false, default: '' },
            enableRemove: { type: Boolean, requires: false, default: true },
            labelClass: { type: String, default: 'font-weight-normal' }
        },

        data() {
            return {
                imageFile: '',
                loadImageErrorMessage: '',
                fileReader: null,
                imageTooLarge: false
            };
        },

        computed: {

            imageData() {
                return this.value;
            },

        },

        methods: {

            /*
            * Removes the loaded image
            */
            $_removeImage() {
                // get the bound data-fieldname property
                const dataFieldname = this.$refs.imageViewer.getAttribute('data-fieldname');
                // send removed image event
                this.$emit('removed', dataFieldname);
            },
            $_clickImage($event) {
                this.$emit('clicked', $event);
            }
        },
    };
</script>

<style lang="scss" scoped>

    #feedback-imageviewer-container {
        display: block;
        margin:0px;
        padding:0px;
        width: 100%;
    }

    .photo-group {
        display: block;
        margin:0px;
        padding:0px;
        width: 100%;
    }

    .feedback-photo-image {
        max-width: 100%;
    }

    .photo-control {
        margin-top:10px;
        background:#fff;
        cursor:pointer;
        border-radius: 0.25rem;
    }

    .photo-icon {
        color: #007AC9;
        margin-left: 10px;
    }

    .photo-title {
        margin-left:10px;
        margin-right:10px;
    }

</style>
